import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { HeroSection } from "@faire/retailer-visitor-shared/views/careers/__internal__/components/HeroSection";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var BelongingHeroSection = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var headerText = strictLocalize({
        id: "/uxe+u",
        defaultMessage: [
            {
                type: 0,
                value: "Celebrating diversity"
            }
        ]
    });
    var eyebrowText = strictLocalize({
        id: "OsFESb",
        defaultMessage: [
            {
                type: 0,
                value: "Belonging At Faire"
            }
        ]
    });
    var IMAGES = [
        "https://cdn.faire.com/fastly/b7ccc6bf09875cdb0853bfdb936c8a9f7f946e4d3e28371c058e53d85ae65759.png"
    ];
    var isDesktopAndAbove = useViewport().isDesktopAndAbove;
    return /*#__PURE__*/ _jsxs(HeroSection, {
        eyebrowText: eyebrowText,
        eyebrowColor: Core.icon.inverse,
        heroImages: IMAGES,
        backgroundColor: Decorative.shade.yellow,
        children: [
            /*#__PURE__*/ _jsx(MobileTextWidth, {
                variant: {
                    mobileAndAbove: "displayMSerifRegular",
                    desktopAndAbove: "displayLSerifRegular"
                },
                color: Core.text.inverse,
                children: headerText
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: isDesktopAndAbove ? "3x" : "2x"
            }),
            /*#__PURE__*/ _jsx(MobileTextWidth, {
                color: Core.text.inverse,
                variant: {
                    mobileAndAbove: "paragraphSansRegular",
                    desktopAndAbove: "subheadingSansMedium"
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "vnuIX7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "We\u2019re committed to building diverse teams and supporting all of our communities at Faire."
                        }
                    ]
                })
            })
        ]
    });
};
var MobileTextWidth = styled(Typography).withConfig({
    componentId: "sc-e13212f7-0"
})([
    "",
    "{max-width:",
    ";}"
], responsiveMediaQueries.mobile, getSpacing(230));
